import React from 'react';
import { CircularProgress, TextField, Typography } from '@material-ui/core';
import { Button } from '@sharedComponents/DesignSystem/Inputs';
import { translate } from '@utils';
import { useChangeRole } from '@hooks/useChangeRole';

import './index.scss';
import { RoleConfigurationList } from '@components/Pages/DashboardPage/RolesPage/RoleConfigurationList';

const EditRolePage = () => {
  const {
    editValue,
    errorText,
    handleInputChange,
    handleEditRole,
    handleCancel,
    currentRolePermissions,
    isSaving,
    disablePage,
  } = useChangeRole();

  return (
    <div className="edit-role-page-container" data-testid="edit-role-page-container">
      <Typography
        data-testid="edit-role-page-title"
        className="edit-role-page-heading"
        component="h3"
        variant="h6"
      >
        {translate('edit_role')}
      </Typography>

      <TextField
        required
        label="Role name(ENG)"
        placeholder="Name"
        value={editValue}
        className="edit-group-field"
        onChange={handleInputChange}
        autoFocus
        fullWidth
        helperText={errorText}
        id="standard-full-width"
        InputLabelProps={{
          shrink: true,
        }}
      />
      {isSaving && (
        <CircularProgress style={{ position: 'fixed', top: '50%', left: '50%', zIndex: '9999' }} />
      )}
      {currentRolePermissions && (
        <div style={disablePage()}>
          <RoleConfigurationList />
        </div>
      )}
      <div className="edit-role-page-buttons" data-testid="edit-role-page-buttons">
        <Button
          type="basic"
          onClick={handleEditRole}
          disabled={!!errorText || !editValue || isSaving}
        >
          {translate('edit_role')}
        </Button>
        <Button type="stroke" onClick={handleCancel}>
          {translate('cancel')}
        </Button>
      </div>
    </div>
  );
};

export { EditRolePage };
